import ErrorBoundary from '@/components/ErrorBoundary';
import { DefaultComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { Paragraph, ParagraphProps } from './Paragraph';

export interface StandaloneParagraphProps extends StandaloneComponentProps {
  content?: string;
  attributes?: Record<string, string>;
  options?: ParagraphProps;
}

export const StandaloneParagraph: StandaloneComponent<StandaloneParagraphProps> = ({
  content,
  attributes,
  options,
  ...props
}) => {
  return (
    <ErrorBoundary>
      <Paragraph content={content} attributes={attributes} {...options} {...props} />
    </ErrorBoundary>
  );
};

const DefaultParagraph: DefaultComponent = ({ type, data, meta, descendants }) => {
  return (
    <StandaloneParagraph content={data.content} attributes={meta.attributes} {...withDebugMetadata({ type, meta })} />
  );
};

export const standalone = StandaloneParagraph;

export default DefaultParagraph;
